import FieldNewPassword from './FieldNewPassword';
export default FieldNewPassword;
